import { User } from '../../shared/models/user';

export function hasScopeGroup(user: User) {
  return user?.roles?.some(role => role.scopeGroups?.length > 0) ?? false;
}
